<template>
  <div class="col-12">
    <px-card title="Latest orders">
      <div class="card-body">
        <div class="d-flex justify-content-end mb-2">
          <button
            class="btn btn-light btn-sm"
            :disabled="!rows.length"
            @click="exportCSV"
          >
            <feather
              type="download"
              style="width:14px;height:14px"
              class="mr-1"
            ></feather>
            Export CSV
          </button>
        </div>
        <div class="table-responsive">
          <b-table
            small
            hover
            bordered
            head-variant="light"
            show-empty
            empty-text="No orders for this store yet."
            :items="rows"
            :fields="fields"
          >
            <template #cell(customer)="field">
              <div>{{ field.item.customer }}</div>
              <small v-if="field.item.email" class="text-muted">
                {{ field.item.email }}
              </small>
            </template>
            <template #cell(payment)="field">
              <span class="badge badge-glow badge-secondary">
                {{ field.item.payment }}
              </span>
            </template>
            <template #cell(status)="field">
              <span :class="'badge badge-glow badge-' + statusVariant(field.value)">
                {{ field.value }}
              </span>
            </template>
            <template #cell(amt)="field">
              {{ formatMoney(field.value, stats.currencySymbol) }}
            </template>
          </b-table>
        </div>
      </div>
    </px-card>
  </div>
</template>

<script>
import {
  downloadCSV,
  formatMoney,
  formatDate
} from "../../../utils/store-stats";

export default {
  name: "latest-orders-table",
  props: {
    stats: { type: Object, required: true }
  },
  data() {
    return {
      fields: [
        { key: "transactionId", label: "Order" },
        { key: "dateLabel", label: "Date" },
        { key: "customer", label: "Customer" },
        { key: "payment", label: "Payment" },
        { key: "status", label: "Status" },
        { key: "amt", label: "Total" }
      ]
    };
  },
  computed: {
    rows() {
      return (this.stats.latestOrders || []).map((order) => ({
        transactionId: order.transactionId,
        dateLabel: formatDate(order.date, order.dateRaw || ""),
        customer: order.customer || "—",
        email: order.email,
        payment: order.payment,
        status: order.status,
        amt: order.amt
      }));
    }
  },
  methods: {
    formatMoney,
    statusVariant(status) {
      const map = {
        Processing: "primary",
        Shipped: "warning",
        Delivered: "success",
        Cancelled: "danger"
      };
      return map[status] || "secondary";
    },
    exportCSV() {
      const rows = this.rows.map((row) => ({
        Order: row.transactionId,
        Date: row.dateLabel,
        Customer: row.customer,
        Email: row.email,
        Payment: row.payment,
        Status: row.status,
        Total: row.amt
      }));
      const date = new Date().toISOString().slice(0, 10);
      downloadCSV(rows, "latest-orders-" + date + ".csv");
    }
  }
};
</script>

<style></style>
